import { Table } from 'antd';
import _ from 'lodash';
import React from 'react';
import { BaseCard } from '../BaseCard';
import './CardGenderByAge.scss';
import { ICON_LABEL } from './constant/iconLabel';
import { ArrowSortIcon } from './icons';

/**
 * @author Renta<renta.yustika@bvarta.com>
 * @copyright PT Bhumi Varta Technology
 * @type {React.FC<{
 * data:Array<{key:string,male:{value:number,percentage:number},female:{value:number,percentage:number},total:{value:number,percentage:number}}>
 * isLoading:boolean
 * style?:React.CSSProperties
 * title: string
 * }>}
 */

export const CardGenderByAge = (props) => {
  const { isLoading, data, style, title = 'Gender by Age' } = props;

  /**
   * @type {(par:number)=>void}
   */
  const numberWithDots = (num) => {
    return num?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  };

  /**
   * @type {(par:number)=>void}
   */
  const getPercentage = (par) => par?.toFixed(2).toString().replace('.', ',');

  const renderTotal = (v) => {
    return (
      <React.Fragment>
        <div className='icon-sort'>
          <ArrowSortIcon
            activeSort={v?.sortColumns?.[0]?.order === 'ascend'}
          />
          <ArrowSortIcon
            activeSort={v?.sortColumns?.[0]?.order === 'descend'}
          />
        </div>
        Total
      </React.Fragment>
    );
  };

  return (
    <div className='shared CardGenderByAge' style={style}>
      <BaseCard isLoading={isLoading} title={title} withPadding={true}>
        <Table
          className='CardGenderByAge__table'
          columns={[
            {
              dataIndex: 'key',
              key: 'key',
              title: 'Age',
              align: 'center',
              render: (v) => {
                const selectedAge = _.filter(
                  ICON_LABEL,
                  (a) => a?.key === v
                )?.[0];
                return (
                  <div className='CardGenderByAge__table__cell'>
                    {selectedAge?.icon}
                    <span>{selectedAge?.label}</span>
                    <span>{selectedAge?.desc}</span>
                  </div>
                );
              },
            },
            {
              dataIndex: 'male',
              key: 'male',
              title: 'Male',
              align: 'center',
              render: (v) => {
                return (
                  <div className='CardGenderByAge__table__cell'>
                    <b className='blue-tag'>{numberWithDots(v?.value)}</b>
                    <span className='percentage'>
                      {getPercentage(v?.percentage)} %
                    </span>
                  </div>
                );
              },
            },
            {
              dataIndex: 'female',
              key: 'female',
              title: 'Female',
              align: 'center',
              render: (v) => {
                return (
                  <div className='CardGenderByAge__table__cell'>
                    <b className='pink-tag'>{numberWithDots(v?.value)}</b>
                    <span className='percentage'>
                      {getPercentage(v?.percentage)} %
                    </span>
                  </div>
                );
              },
            },
            {
              dataIndex: 'total',
              key: 'total',
              title: renderTotal,
              align: 'center',
              showSorterTooltip: false,
              sorter: (a, b) => a?.total?.value - b?.total?.value,
              render: (v) => {
                return (
                  <div className='CardGenderByAge__table__cell'>
                    <b className='total-tag'>{numberWithDots(v?.value)}</b>
                    <span className='percentage'>
                      {getPercentage(v?.percentage)} %
                    </span>
                  </div>
                );
              },
            },
          ]}
          dataSource={data || []}
          pagination={false}
        />
      </BaseCard>
    </div>
  );
};

CardGenderByAge.displayName = 'CardGenderByAge';
